import {
  all,
  put,
  call,
  takeLatest,
  takeEvery, select
} from "redux-saga/effects";
import apiGet from "./axiosGet";
import apiPostReport from "./axiosPostReport";
import { isEmpty } from "../../Helper/gm";
import { spinnerLoading, localStorageSet } from "../../sagas/saga_helper";
import loginCheckSage from "../../sagas/login_check_sage";
import getNewAccess from "../../sagas/get_new_access";
import eventLog from "../../sagas/event_log";


function* spinnerOn(name, v) {
  yield put({
    type: "PARTNERS_SPINNER",
    name: name,
    addBy: v,
  });
}

function* spinnerReset() {
  yield put({
    type: "SPA_SPINNER",
    addBy: 0
  });
}

/*스피너 동기 처리*/

function* secondCall(d, res) {
  const { key_list, option } = d;

  let new_url = `${option.url}?page=${
    isEmpty(option.page) ? 1 : option.page
  }&tab_type=${isEmpty(option.tab_type) ? 0 : option.page}`;

  key_list.map(
    d => (new_url += `&${d}=${JSON.stringify(res[`default_${d}`])}`)
  );

  const new_option = Object.assign(d, {
    option: {
      url: new_url
    }
  });

  yield call(workerSaga, new_option);
}

function* workerSaga(option) {
  try {
    /*api콜*/
    yield call(spinnerLoading, "on");
    const response = yield call(apiGet, option.option);
    yield call(spinnerLoading, "off");
    if (response.data.code > 299) {
      yield call(spinnerLoading, "end");
      console.log("500 Error");
    }
    if (isEmpty(option.modal_name)) {
      yield put({
        type: option.action,
        addBy: response.data,
        name: option.name
      });
    } else {
      yield put({
        type: option.action,
        addBy: response.data,
        name: option.name,
        top: option.top,
        modal_name: option.modal_name
      });
    }
    if (!isEmpty(option.second_api)) {
      yield call(secondCall, option.second_api, response.data.data);
    }
  } catch (error) {
    yield call(spinnerLoading, "end", error.response);
    if(!isEmpty(error.response.status)){
      if (error.response.status === 500) {
        console.log(error.response["status"], option);
        window.location.href = `${process.env.REACT_APP_BACKEND_HOST}`;
      }
    }

    if(localStorageGet("jobplanet_login") === "login_check_error") return;
    localStorageSet("jobplanet_spa", "error");
    window.location.href = "/error";
  }
}

function* openDetailModal(option){
  try {
    let { loading } = yield select();
    if(loading === 0){
      yield call(spinnerLoading, "on");
    }
    const response = yield call(apiGet, option.option);
    if (response.data.status === "success") {
      yield call(spinnerLoading, "off");
      yield put({
        type: option.action,
        addBy:  {
          data: response.data.data
        },
        modal_name: option.modal_name,
        name: option.modal_name,
        top: option.option.top,
      });
      yield eventLog(option.option.event_log);
    } else {
      alert("오류");
    }
  } catch (error) {
    if(error.response.status === 401){
      /* token이 만료됐을 경우 401 에러 발생 */
      yield getNewAccess();
      yield call(openDetailModal, option);
    }else{
      /* token 에러가 아닐 경우 */
      console.log(error);
      if(error.message.indexOf("500") > 0){
        window.location.href = `/error/500`;
      }
      if(error.message.indexOf("503") > 0){
        window.location.href = `/error/503`;
      }
    }
  }
}

function* closeServiceModal (option){
  yield put({
    type: option.action,
    addBy: option.data,
    name: option.name,
  })
}

/* partners section 별 api call */
function* partnersSectionApiGet(option){
  try{
    /* 어떤 섹션에 spinner를 열 것인가, 전체 스피너(total)를 켤 것인지 섹션 스피너(section)를 켤 것인지 선택 가능 */
    if(!isEmpty(option.option.spinner)){
      option.option.spinner === "total" ?  yield call(spinnerLoading, "on") :  yield call(spinnerOn, option.name, true);
    }
    const response = yield call(apiGet, option.option);
    if(!isEmpty(option.option.spinner) && option.option.spinner === "total"){
      yield call(spinnerLoading, "off");
    }
    if (response.data.status === "success") {
      yield put({
        type: option.action,
        addBy: Object.assign({}, { is_error: false, is_spinner: false}, {contents: response.data.data}),
        name: option.name
      });
    }else{
      yield put({
        type: option.action,
        addBy: Object.assign({}, { is_error: true, is_spinner: false}, {contents: []}),
        name: option.name
      });
    }
  }catch(error){
    if(error.response.status === 401){
      /* 토큰 만료 시 새로운 토큰 get */
      yield getNewAccess();
      yield call(partnersSectionApiGet, option);
    }
    if(error.response.status === 404){
      /* api가 없는 경우 예외처리 */
      yield put({
        type: option.action,
        addBy: Object.assign({}, { is_error: true, is_spinner: false}, {contents: []}),
        name: option.name
      });
    }
    if(error.message.indexOf("500") > 0){
      window.location.href = `/error/500`;
    }
    if(error.message.indexOf("503") > 0){
      window.location.href = `/error/503`;
    }
  }
}

function* setPartnersModal({payload}){
  yield put({
    type: "PARTNERS_SET_MODAL",
    addBy: payload,
  });
}

function* getClaimInfo({payload}){
  try {
    const response = yield call(apiGet, payload);
    if (response.status === 200) {
      yield put({
        type: "SET_MODAL_INFO",
        addBy: {
          data: response.data?.data
        },
      });
    }
  } catch (error) {
    window.location.href = "/error";
  }
}

function* setClaimInfo({payload}){
  try {
    yield call(apiPostReport, payload);
  } catch (error) {
    window.location.href = "/error";
  }
}

/*SPA_SPINNER_RESET 알리, 파트너스 모두 사용 중*/
export function* rootSaga() {
  yield all([
    yield takeEvery("SPA_SPINNER_RESET", spinnerReset),
    yield takeLatest("LOGIN_CHECK", loginCheckSage),
    yield takeEvery("PARTNERS_CALL", workerSaga),
    yield takeEvery("PARTNERS_GET", partnersSectionApiGet),
    yield takeLatest("SHOW_DETAIL_MODAL", openDetailModal),
    yield takeLatest("CLOSE_SERVICE_MODAL", closeServiceModal),
    yield takeLatest("SET_MODAL", setPartnersModal),
    yield takeLatest("GET_CLAIM_INFO", getClaimInfo),
    yield takeLatest("SET_CLAIM_INFO", setClaimInfo),
  ]);
}
